import { render, staticRenderFns } from "./TableCellFullName.vue?vue&type=template&id=2a677d90"
import script from "./TableCellFullName.vue?vue&type=script&lang=js"
export * from "./TableCellFullName.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports